import { Routes, Route, Navigate } from 'react-router-dom';

import Login from '../pages/Login';
import GuestSplashScreen from '../components/GuestSplashScreen';

const AuthRoutes = () => {
  const hasLastUser = Boolean(localStorage.getItem('lastUserId'));
  const defaultRedirect = <Navigate to={hasLastUser ? '/login' : '/play-as-guest'} replace />;

  return (
    <Routes>
      <Route path="/login" element={hasLastUser ? <Login /> : <Navigate to="/play-as-guest" replace />} />
      <Route path="/play-as-guest" element={<GuestSplashScreen />} />
      <Route path="*" element={defaultRedirect} />
    </Routes>
  );
};

export default AuthRoutes;
